import createIcon from '../../createIcon';

/**
 * @component @name PlaylistAdd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSA5SDIuNVYxMUgxMy41VjlaTTEzLjUgNUgyLjVWN0gxMy41VjVaTTE3LjUgMTNWOUgxNS41VjEzSDExLjVWMTVIMTUuNVYxOUgxNy41VjE1SDIxLjVWMTNIMTcuNVpNMi41IDE1SDkuNVYxM0gyLjVWMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlaylistAdd = createIcon('PlaylistAdd', [
  [
    'path',
    {
      d: 'M13.5 9H2.5V11H13.5V9ZM13.5 5H2.5V7H13.5V5ZM17.5 13V9H15.5V13H11.5V15H15.5V19H17.5V15H21.5V13H17.5ZM2.5 15H9.5V13H2.5V15Z',
      key: '76ptfi',
    },
  ],
]);

export default PlaylistAdd;
